<script>
  import { getProductUrlAndImages, shareOnPlatform } from './get-share-url'
  import { getImageUrl, clickOutside } from '../../utils'
  import openShareWindow from './open-window'
  import configMod from '../../config'
  import Spinner from '../Spinner.svelte'

  export let shareId
  export let currentShareId
  export let shopUrl
  export let review
  export let widgetType
  export let accountLogo
  export let toggleShare
  export let isPopup = true
  export let shareToText

  let loading = false

  const config = configMod()
  const baseUrl = config.shareUrl

  const shareOnSocialMedia = async platform => {
    let productUrl, productImages
    loading = true
    try {
      const response =
        !review.is_business && (await getProductUrlAndImages(review))
      productUrl = response.productUrl
      productImages = response.productImages
    } catch (_) {
      productUrl = shopUrl
      productImages = []
    }

    loading = false

    const imageUrl = getImageUrl({ review, accountLogo, productImages })

    const id = review.id
    const productReviewUrl = productUrl
    const url = review.is_business ? shopUrl : productReviewUrl

    const uri = encodeURIComponent(`${url}`)
    const imageUri = encodeURIComponent(`${imageUrl}`)

    const shareUrl = `${baseUrl}/reviews/${id}?url=${uri}&social_platform=${platform}&utm_medium=${widgetType}&image=${imageUri}`
    const plainUrl = `${baseUrl}/reviews/${id}?url=${url}&social_platform=${platform}&utm_medium=${widgetType}&image=${imageUrl}`

    const platformReviewShareUrl = shareOnPlatform(shareUrl, platform, plainUrl)

    if (platformReviewShareUrl) openShareWindow(platformReviewShareUrl)
  }

  let element
  let showShare = true

  $: if (isPopup) showShare = currentShareId === shareId

  const handleClick = event => {
    isPopup && toggleShare()
  }
</script>

<style>
  :global(.dropdown-box-znsUa7) {
    font-size: 13px;
    box-sizing: border-box;
    margin: 0px 4px;
    position: absolute;
    border-radius: 4px;
    background: rgb(255, 255, 255) none repeat scroll 0% 0%;
    box-shadow: rgba(38, 42, 79, 0.2) 0px 22px 24px 0px;
    padding: 16px;
    z-index: 9;
    left: 0px;
    text-align: left;
    top: -90px !important;
    right: 0px;
    width: unset;
    min-width: 110px !important;
    line-height: normal;
  }

  :global(.share-text-Ybs8GT) {
    font-size: 13px;
    color: rgb(105, 108, 133);
    cursor: default;
    font-weight: 400;
    margin-left: 0px !important;
    box-sizing: border-box;
    margin-top: 0px;
    margin-right: 4px;
    margin-bottom: 0px;
  }

  ul {
    display: inline-flex;
    list-style-type: none;
    margin: 0px;
    padding: 0px;
  }

  li {
    padding: 8px 1px 0px 8px !important;
    margin-bottom: 0px;
    border-radius: 4px;
    margin-left: -8px;
    margin-right: -8px;
    display: flex;
    -moz-box-align: center;
    align-items: center;
    position: relative;
  }
  a {
    padding: 4px;
    margin-right: 16px !important;
    transform: scale(1);
    display: inline-flex;
    -moz-box-align: center;
    align-items: center;
    text-decoration: none;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0) 0px 1px 3px 0px;
    text-align: center;
    letter-spacing: -0.1px;
    white-space: nowrap;
    color: rgb(68, 102, 228);
    transition: all 0.1s ease 0s;
  }

  a:hover,
  a:active {
    background: #e4e8ec;
  }

  :global(.spinner-35v07s) {
    position: absolute;
    right: -40%;
  }
</style>

{#if showShare}
  <div
    use:clickOutside
    on:click_outside={handleClick}
    bind:this={element}
    class={isPopup ? 'dropdown-box-znsUa7' : ''}>
    <div class="share-text-Ybs8GT">{shareToText}:</div>
    <ul>
      <li>
        <a
          href="javascript:void(0)"
          on:click={() => shareOnSocialMedia('twitter')}>
          <div>
            <img
              src="https://statisc2test.kudobuzz.com/icons/icon-twitter.svg"
              alt="Share to Twitter" />
          </div>
        </a>
      </li>
      <li>
        <a
          href="javascript:void(0)"
          on:click={() => shareOnSocialMedia('facebook')}>
          <div>
            <img
              src="https://statisc2test.kudobuzz.com/icons/icon-facebook-square.svg"
              alt="Share to Facebook" />
          </div>
        </a>
      </li>
    </ul>
  </div>
{/if}
{#if loading}
  <span class="spinner-35v07s">
    <Spinner />
  </span>
{/if}
